let exeStatus = {
  paymentMethods: {},
  voucher: '',
  insurance: null,
  products: {},
  items: {},
  priceOptions: {}
};

function setExeStatus(status) {
  exeStatus = status;
}

function getExeStatus() {
  return exeStatus;
}

export {
  setExeStatus,
  getExeStatus
}